import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Radio({ className, ...rest }) {
    return (_jsx("input", { className: classNames(className, "cvr-control", {
            checked: rest.checked,
        }), type: "radio", ...rest }));
}
